import React from 'react'
import styled from 'styled-components'
import Assistance from './Assistance'
import Checkins from './Checkins'
import Attendance from './Attendance'
import CenterVisitAverage from './CenterVisitAverage'
import StudentCheckin from './StudentCheckin'
import AvgAttendance from './AvgAttendance'
import TotalAttendanceByHour from './TotalAttendanceByHour'
import TeacherDistribution from './TeacherDistribution'
import ActiveCheckins from './ActiveCheckins'

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const ReportContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
`
const TitleContainer = styled.div`
  width: 100%;
  height: 100px;
  padding: 0 30px 30px 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const AttendanceReports = ({ fromCenter, match }) => (
  <Container>
    {!fromCenter && (
      <TitleContainer>
        <h1>Asistencias</h1>
      </TitleContainer>
    )}
    <ReportContainer>
      <Assistance match={match} fromCenter={fromCenter}/>
      <Checkins match={match} fromCenter={fromCenter} />
      <Attendance match={match} fromCenter={fromCenter} />
      <CenterVisitAverage match={match} fromCenter={fromCenter} />
      <StudentCheckin match={match} fromCenter={fromCenter} />
      <AvgAttendance match={match} fromCenter={fromCenter} />
      <TotalAttendanceByHour match={match} fromCenter={fromCenter} />
      <TeacherDistribution match={match} fromCenter={fromCenter} />
      <ActiveCheckins match={match} fromCenter={fromCenter} />
    </ReportContainer>
  </Container>
)

export default AttendanceReports



// WEBPACK FOOTER //
// ./src/Containers/Reports/AttendanceReports.jsx